module.exports = __webpack_public_path__ + "img/dyamicOneImg.32833180.png";